import { useState, useEffect } from 'react';

export const MOBILE_BREAKPOINT = 768;

export function useScreenSize() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { width, isMobile: width < MOBILE_BREAKPOINT };
}
